import { useEffect, useState } from 'react';
import { publicSettings } from '../api/publicSettings';

/**
 * A legal text as the operator wrote it in Settings, Terms and privacy
 * (`GET public/legal`; "a blank line starts a paragraph"), or, until they
 * have, the text this app always carried (`children`). InGo's own texts are
 * KIGATTA's to write; nothing here invents one.
 *
 * @param {{ which: 'terms' | 'privacy', children: import('react').ReactNode }} props
 */
export default function LegalText({ which, children }) {
  const [text, setText] = useState(null);

  useEffect(() => {
    let gone = false;
    publicSettings.legal().then(
      (documents) => !gone && setText(documents[which]),
      // Not reachable: the app's own text stays.
      () => {},
    );

    return () => {
      gone = true;
    };
  }, [which]);

  if (!text) return children;

  return text
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph, index) => (
      <section key={index} className="legal-section">
        <p style={{ whiteSpace: 'pre-line' }}>{paragraph}</p>
      </section>
    ));
}
